module.exports = __webpack_public_path__ + "assets/img/zf1.a4e21880.png";